import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=5ef9eea7&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=5ef9eea7&prod&lang=css"
import style1 from "./Collection.vue?vue&type=style&index=1&id=5ef9eea7&prod&lang=scss&scoped=true"
import style2 from "./Collection.vue?vue&type=style&index=2&id=5ef9eea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9eea7",
  null
  
)

export default component.exports